import { gql } from "@apollo/client";


export const GET_EMPLOYEE_PERFORMANCE = gql`
  query EmployeePerformanceStats($startDate: String, $endDate: String) {
    EmployeePerformanceStats(startDate: $startDate, endDate: $endDate) {
      employeeId
      employeeName
      clientName
      totalRequests
      totalHours
      productive {
        emails
        processing
        quality
        totalProductiveHours
      }
      nonProductiveHours
      dueDate
      completedDate
    }
  }
`;
export const GET_OPERATION_EMPLOYEE_PERFORMANCE = gql`
  query GetOperationEmployeePerformance(
    $employeeId: String!
    $startDate: String!
    $endDate: String!
  ) {
    EmployeeViewPerformance(
      employeeId: $employeeId
      startDate: $startDate
      endDate: $endDate
    ) {
      employeeId
      employeeName
      clientName
      totalHours
      totalRequests

      productive {
        emails
        processing
        totalProductiveHours
        nonProductiveHours
        nonProductiveTasks {
          task
          hours
        }
      }

      dueDate
      completedDate
    }
  }
`;
